import { UserRating } from "./userRating.organism";

export default UserRating;
